import { AvvirEvent } from "type_aliases";

export type ProcoreObservationAssigneesLoadedEvent = AvvirEvent<typeof PROCORE_OBSERVATION_ASSIGNEES_LOADED, any>

const procoreObservationAssigneesLoaded = (procoreAssignees): ProcoreObservationAssigneesLoadedEvent => ({
  type: PROCORE_OBSERVATION_ASSIGNEES_LOADED,
  payload: procoreAssignees
});

export const PROCORE_OBSERVATION_ASSIGNEES_LOADED = "procore_observation_assignees_loaded";

export default procoreObservationAssigneesLoaded;
